const GT_WEB_CLOUDFRONT = 'https://d3hz2dasjf76zw.cloudfront.net';

const APP_ID = 'gt-response-generator'; // test-nk
// const APP_ID = 'gt-response-generator-dev'; // localhost

// Prod check
// const GT_DOMAIN = 'https://gtengage.guesttouch.com';
const GT_DOMAIN = 'https://app.guesttouch.com';

// Default is Dev
let v_DATA_BACKEND_URL = 'https://0t7s1lkl5c.execute-api.us-west-2.amazonaws.com/wldvdmhr901epu564omy24t2kk4n9bsgh42v8ud9/gtapi/jgljmtld9i-prod/v1';
v_DATA_BACKEND_URL = 'https://70uyae3w2m.execute-api.us-west-2.amazonaws.com/h6np35g1evu3fat7e0jx2rawkxxzl2sfi0nzxouw/webappapi/wf';
// v_DATA_BACKEND_URL = `${v_DATA_BACKEND_URL}/engageapi/test`;
let v_DATA_BACKEND_URL_API_KEY = 'eMTpBmL1DO8jOBmZNnpwu7mHBhiyRRAd70rHVwkR';

// if (process.env.NODE_ENV === 'production') {
//   // Prod
//   v_DATA_BACKEND_URL = 'https://bu27gxkoz6.execute-api.us-west-2.amazonaws.com/rq3v82j0k1m5t6hpsns17qqg92spz6adidxkcvp4';
//   v_DATA_BACKEND_URL_API_KEY = 'KxxD5emGOz8sV6vY3Q49G5ETlhI3ddMKa7hkMkNo';
//
//   v_DATA_NF_BACKEND_URL = 'https://2g7fn6zrlc.execute-api.us-west-2.amazonaws.com/fiqbntkumqu8ee1u35v06xqk2ai631na1br03mb8';
//   v_DATA_NF_BACKEND_URL = `${v_DATA_NF_BACKEND_URL}/engageapi/nf`;
//   v_DATA_NF_BACKEND_URL = `${GT_DOMAIN}/engageapi/nf`;
//   v_DATA_NF_BACKEND_URL_API_KEY = 'EkvA5Hwt8c8mvqTrVNlZj30ndvvyq1s9735V6PHL';
//
//   v_DATA_WF_BACKEND_URL = 'https://2g7fn6zrlc.execute-api.us-west-2.amazonaws.com/fiqbntkumqu8ee1u35v06xqk2ai631na1br03mb8';
//   v_DATA_WF_BACKEND_URL = `${v_DATA_WF_BACKEND_URL}/engageapi/wf`;
//   v_DATA_WF_BACKEND_URL = `${GT_DOMAIN}/engageapi/wf`;
//   v_DATA_WF_BACKEND_URL_API_KEY = 'EkvA5Hwt8c8mvqTrVNlZj30ndvvyq1s9735V6PHL';
//
// }

module.exports = {
  APP_ID,
  GT_VERSION: 'v0.0.1',
  APP_NAME: 'GT_UNIFIED',
  DISPLAY_NAME: 'GT Unified',

  // Dev
  DATA_BACKEND_URL: v_DATA_BACKEND_URL,
  DATA_BACKEND_URL_API_KEY: v_DATA_BACKEND_URL_API_KEY,

  EMAIL_ALERT_URL: 'https://yhkxzzlvo5.execute-api.us-west-2.amazonaws.com/uowhrrhixqiieqez0btl791byp2t7iivzc7g7054',
  EMAIL_ALERT_API_KEY: 'l36mToJaS12Amdjm6D3PD3vFbg61CgCZ6QvKp1hY',
  EMAIL_ALERT_URL_GT_BASIC_KEY: 'PJjnDwbTBvXGRZ3CS2ZGqXrGA0iR8uLX',

  PUSHER_APP_KEY: 'b73cfef6d5b814cd2214',
  PUSHER_APP_CLUSTER: 'us3',

  TRIPADVISOR_LOGO: GT_WEB_CLOUDFRONT + '/images/ota/tripadvisor-logo.png',
  BOOKING_LOGO: GT_WEB_CLOUDFRONT + '/images/ota/booking-logo.png',
  EXPEDIA_LOGO: GT_WEB_CLOUDFRONT + '/images/ota/expedia-logo.png',
  GOOGLE_LOGO: GT_WEB_CLOUDFRONT + '/images/ota/google-logo.png',
  HOTELSCOM_LOGO: GT_WEB_CLOUDFRONT + '/images/ota/hotelscom-logo.png',
  HOSTELWORLD_LOGO: GT_WEB_CLOUDFRONT + '/images/ota/hostelworld-logo.png',
  MMT_LOGO: GT_WEB_CLOUDFRONT + '/images/ota/mmt-logo.png',
  AGODA_LOGO: GT_WEB_CLOUDFRONT + '/images/ota/agoda-logo.png',
  AIRBNB_LOGO: GT_WEB_CLOUDFRONT + '/images/ota/airbnb-logo.png',
  VRBO_LOGO: GT_WEB_CLOUDFRONT + '/images/ota/vrbo-logo.jpg',
  HOLIDAYCHECK_LOGO: GT_WEB_CLOUDFRONT + '/images/ota/holiday-check-logo-small.png',
  HOLIDAYCHECK_LOGO_LONG: 'https://s3.amazonaws.com/guesttouch/assets/images/holiday-check-logo.png',

  CONNECT_REVIEWS_WIDGET_URL: 'https://d2b1q31aafwen6.cloudfront.net/dashboard/img/connect-reviews-widget.png',
  CONNECT_PMS_URL: 'https://d2b1q31aafwen6.cloudfront.net/dashboard/img/connect-pms.png',

  FEEDBACK_HAPPY: 'https://s3.amazonaws.com/guesttouch/assets/images/happiness-64x64.png',
  FEEDBACK_SAD: 'https://s3.amazonaws.com/guesttouch/assets/images/sad-64x64.png',

};
